import {AfterViewInit, Component, Inject, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ReportsService} from '../../reports.service';
import {AgentGroupsSummaryService} from '../agent-groups-summary.service';
import {GroupAgentsSummaryFilterModel} from '../../../api/models/group-agents-summary-filter-model';
import {GroupAgentsSummaryDatasource} from './group-agents-summary.datasource';
import {MatPaginator} from '@angular/material/paginator';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import {ReportsService as GroupsReportsApiService} from '../../../api/services/reports.service';
import {merge} from 'rxjs';
import {tap} from 'rxjs/operators';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import {CallLogsDialogComponent} from '../../call-logs/call-logs-dialog.component';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton, MatMiniFabButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf, NgFor, AsyncPipe, DecimalPipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatTooltip } from '@angular/material/tooltip';
import { Angular2PromiseButtonModule } from 'angular2-promise-buttons';

export interface GroupsAgentSummaryFilterData {
  group: string;
  startDate: string;
  endDate: string;
}

@Component({
    selector: 'app-groups-agent-summary-dialog',
    templateUrl: './group-agents-summary-dialog.component.html',
    styleUrls: ['./group-agents-summary-dialog.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        MatDialogTitle,
        MatIconButton,
        MatDialogClose,
        MatIcon,
        MatDialogContent,
        NgIf,
        MatProgressSpinner,
        MatTable,
        MatSort,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatSortHeader,
        MatCellDef,
        MatCell,
        MatMiniFabButton,
        MatTooltip,
        NgFor,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        MatPaginator,
        MatDialogActions,
        MatButton,
        Angular2PromiseButtonModule,
        AsyncPipe,
        DecimalPipe,
    ],
})
export class GroupAgentsSummaryDialogComponent implements OnInit, OnDestroy, AfterViewInit {

  displayedColumns: string[] = [
    'extension',
    'name',
    'totalLoggedIn',
    'totalAnswered',
    'totalMissed',
    'durationRing',
    'avgDurationRing',
    'durationTalk',
    'avgDurationTalk',
    'surveys',
  ];
  dataSource: GroupAgentsSummaryDatasource;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  @Input() asyncConfirm: (filter: any) => Promise<void>;

  onConfirm: Promise<void>;

  constructor(public reportsService: ReportsService,
              public groupsSummaryService: AgentGroupsSummaryService,
              private callLogsApiService: GroupsReportsApiService,
              public dialog: MatDialog,
              public dialogRef: MatDialogRef<GroupAgentsSummaryDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: GroupsAgentSummaryFilterData,
  ) {

  }

  ngOnInit() {
    console.log('dialog on init');

    this.dataSource = new GroupAgentsSummaryDatasource(this.callLogsApiService);
  }

  ngOnDestroy() {
  }

  ngAfterViewInit() {
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        tap(() => this.loadData())
      )
      .subscribe();

    this.loadData();
  }

  loadData() {
    console.log('filter changed');
    this.dataSource.queryData({
      skip: this.paginator.pageIndex * this.paginator.pageSize,
      limit: this.paginator.pageSize,
      sort: [{field: this.sort.active, direction: this.sort.direction?.toUpperCase()}],
      domain: this.reportsService.selectedDomain,
      startDate: this.data.startDate,
      endDate: this.data.endDate,
      group: this.data.group,
      extensions: []
    });
  }

  async onProcessConfirm() {
    this.onConfirm = this.exportAgentsSummary();
  }

  async exportAgentsSummary() {
    const filter: GroupAgentsSummaryFilterModel = {
      group: this.data.group,
      domain: this.reportsService.selectedDomain,
      startDate: this.data.startDate,
      endDate: this.data.endDate,
      extensions: [],
    };

    await this.groupsSummaryService.exportAgentLogs({
      filter: filter,
      exportFields: this.groupsSummaryService.exportAgentsColumns
    });
  }

  showCallLogsDetails(dataItem: any) {
    console.log(dataItem);
    console.log('open call logs dialog');
    this.dialog.open(CallLogsDialogComponent, {
      width: '90%',
      height: '90%',
      data: {
        filter: {
          extensions: [dataItem.extension],
          groupAccounts: [this.data.group],
          types: ['isIncoming', 'isLocal', 'isOutgoing'],
          startDate: this.data.startDate,
          endDate: this.data.endDate,
          domain: this.reportsService.selectedDomain,
          // excludeStatuses: ['Login', 'Logout']
        }
      }
    });
  }
}
